export const ErrorStyle = {
    color: "#EF4444",
    fontSize: "13px",
    marginTop: "2px",
    // marginTop: "8px",
  };
  